import {
  Box, Typography, Chip, Divider, List, ListItem, ListItemText,
  Drawer,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Tooltip,
} from '@mui/material';

import { BlockedIcon } from '../../../assets/common-svg/CommonSvg';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { memo, useEffect, useState } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import { useLocation, useNavigate, useParams } from 'react-router';
import { useSelector } from 'react-redux';
import DynamicPreview from '../components/features/DynamicPreview';
import { getStatusConfig } from '../../../utils/common';

const FbLayout = ({
  selectedSection,
  selectedField,
  setSelectedSection,
  setSelectedField,
}) => {
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const { id } = useParams();
  const { formState: { errors }, control, getValues } = useFormContext();
  const formsAllData = useWatch({control, name:'sections'});
  const navigate = useNavigate()
 const [selected, setSelected] = useState(null); 

  const templateDetails = useSelector((state) => state?.bmrFbl?.fbTemplate?.items || []);
const currentFormTemplate = templateDetails.find(template => template?.id === +id);

  const statusConfig =getStatusConfig(currentFormTemplate?.status || 0);
  const { text, color, text_color } = statusConfig;

  const location = useLocation();
  const targetPath = `/bmr/fb/${id}`;

  const handlePreviewClick = () => {
    setIsDrawerOpen(true);
  };

  const handleCloseDrawer = () => {
    setIsDrawerOpen(false);
  };
  const handleClick = (path, key) => {
    setSelected(key); // set active item
    navigate(path);
  };
useEffect(() => {
  const path = location.pathname;
  if (path.includes('permission') || path.includes('timeline')) {
    setSelected(path.includes('permission') ? 'permission' : 'timeline');
    setSelectedSection('');
  }
}, [location.pathname]);

  return (
    <Box className=" bg-white rounded-2xl border-[0.11rem] border-white min-h-[98vh]">
      <Box className="p-2 m-0 bg-[#FFEDCB] rounded-t-xl" >
        <Box className='flex justify-between pb-1'>
          <Tooltip
            arrow
            placement="top"
            title={currentFormTemplate?.name}
          >

            <Typography variant="h6" className="font-bold truncate ">
              {currentFormTemplate?.name}
            </Typography>
          </Tooltip>
        </Box>
         {/* @info this draft check is added because its design is chnaged in layout. */}
        {text === 'Draft' ? <Chip
            label={text}
            className={`chip_color text-sm`}
            component="span"
            size='small'
            sx={{
              fontSize: 12,
              backgroundColor: '#FB9D2C',
              '& .MuiChip-label': {
                color: 'white'
              }
            }}
          /> :
          <Chip
            label={text}
            className={`chip_color text-sm`}
            component="span"
            size='small'
            sx={{
              fontSize: 12,
              backgroundColor: color,
              '& .MuiChip-label': {
                color: text_color
              }
            }}
          />
        }
      </Box>
      <Box sx={{ 
        cursor: 'pointer', 
        opacity: 1,
        transition: 'opacity 0.3s ease',
        '&:hover': { opacity: 0.6 }
        }} 
        className={'bg-[#00B278] text-white p-3 '} 
        onClick={handlePreviewClick} >
        <Typography variant="body1" >Preview</Typography>
      </Box>
      <Accordion className='shadow-none m-0 border ' onChange={() => handleClick(`/bmr/fb/${id}/permission`, "permission")} expanded={selected==='permission' || selected==='timeline'}>
        <AccordionSummary className='!bg-[#E8EFFC]'
        sx={{
                         opacity: 1,
          transition: 'opacity 0.3s ease',
          '&:hover': { opacity: 0.6 },
       
          }} 
        expandIcon={<ExpandMoreIcon />} >
          <Typography>Action</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <List disablePadding>
            <ListItem
              dense
              onClick={() => handleClick(`/bmr/fb/${id}/permission`, "permission")}
              className={`cursor-pointer ${selected === "permission" ? "border border-primary rounded-md" : ""
                }`}
            >
              <ListItemText primary="Permission" primaryTypographyProps={{ fontSize: '0.875rem' }}/>
            </ListItem>
            <Divider sx={{ my: 1 }} />
            <ListItem
              dense
              onClick={() => handleClick(`/bmr/fb/${id}/timeline`, "timeline")}
              className={`cursor-pointer ${selected === "timeline" ? "border border-primary rounded-md" : ""
                }`}
            >
              <ListItemText primary="Event Timeline" primaryTypographyProps={{ fontSize: '0.875rem' }}/>
            </ListItem>
            <Divider sx={{ my: 1 }} />
            {/* <ListItem
              dense
              onClick={() => handleClick(`/bmr/fb/${id}/staticText`, "staticText")}
              className={`cursor-pointer ${selected === "staticText" ? "border border-primary rounded-md" : ""
                }`}
            >
              <ListItemText primary="Static Text" primaryTypographyProps={{ fontSize: '0.875rem' }}/>
            </ListItem> */}
          </List>

        </AccordionDetails>
      </Accordion>

      <Box className="border max-h-[29rem] ">
      {formsAllData?.map((section, index) => {
        const sectionError = errors?.sections?.[index];

        const hasSectionError =
          sectionError?.name?.message ||
          sectionError?.description?.message;

        const hasAnyFieldError =
          Array.isArray(sectionError?.fields) &&
          sectionError.fields.some((fieldErr) =>
            fieldErr && Object.values(fieldErr).some((prop) => prop?.message)
          );
        return (
          <Accordion
            key={section?.section_uuid}
            className="shadow-none m-0 border "
            expanded={selectedSection === section?.section_uuid}
            onChange={(e, isExpanded) => {
           setSelected('');   setSelectedSection(isExpanded ? section?.section_uuid : ''); location.pathname !== targetPath && navigate(targetPath);

            }}
          >
            <AccordionSummary expandIcon={<ExpandMoreIcon />} className='!bg-[#E8EFFC]'>
              <Box sx={{ display: 'flex', gap: '0.50rem', alignItems: 'center' }}>
                {(hasSectionError || hasAnyFieldError) && (
                  <BlockedIcon color="error" fontSize="small" />
                )}
                <Typography variant='p' className='truncate capitalize w-48 md:w-36'>
                  {section.name ? `${index + 1}. ${section.name}` : `${index + 1}. Section Name`}
                </Typography>
              </Box>
            </AccordionSummary>

            <AccordionDetails >
              {(section?.fields || []).map((field, fieldIndex) => {
                const fieldError = sectionError?.fields?.[fieldIndex];
                const hasFieldError = fieldError && Object.values(fieldError).some((prop) => prop?.message);

                return (
                  <Box
                    key={field.input_uuid}
                    display="flex"
                    alignItems="center"
                    borderRadius={2}
                    gap={1}
                    className={`mb-2 p-2 cursor-pointer border ${hasFieldError ? 'border-2 !border-red-300' : selectedField === field.input_uuid ? 'border-primary' : ''}`}
                    onClick={() =>
                      setSelectedField(selectedField === field.input_uuid ? '' : field.input_uuid)
                    }
                  >
                    {hasFieldError && <BlockedIcon color="error" fontSize="small" />}
                    <Typography variant='p'  className='truncate capitalize w-48'>
                      {index + 1}.{fieldIndex + 1} {field.label || 'Untitled field'}
                    </Typography>
                  </Box>
                );
              })}
            </AccordionDetails>
          </Accordion>
        );
      })}
      </Box>
      <Drawer
        anchor="right"
        open={isDrawerOpen}
        onClose={handleCloseDrawer}
        PaperProps={{
          sx: {
            width: '74%',
            minWidth: 600,
            maxWidth: 'calc(100% - 64px)',
          }
        }}
      >
        {isDrawerOpen && <DynamicPreview handleCloseDrawer={handleCloseDrawer} getValues={getValues}/>}
      </Drawer>
    </Box>
  );
};

export default memo(FbLayout);